module.exports = __webpack_public_path__ + "media/images/order-card-dfb4eb810797ced2f20b2c80b2c9e8e8.svg";